<template>
  <input-select
    v-model="model"
    :id="id"
    :placeholder="placeholder"
    :disabled="disabled"
    :options="options"
    :position-x="positionX"
    :position-y="positionY"
    :v="v"
  >
    <template #selected-option="{ option }">
      <slot
        name="selected-option"
        :option="option"
      >
        {{ option.label }}
      </slot>
    </template>

    <template #option="{ option }">
      <slot
        name="option"
        :option="option"
      >
        {{ option.label }}
      </slot>
    </template>
  </input-select>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { useCurrencyStore } from '@/stores/CurrencyStore'

import InputSelect from '&/atoms/InputSelect'

const model = defineModel({ type: String, default: '' })

defineProps({
  id: { type: String },
  placeholder: { type: String },
  disabled: { type: Boolean, default: false },
  positionX: { type: String, default: 'left' },
  positionY: { type: String, default: 'bottom' },
  v: { type: Object }
})

const { t } = useI18n()
const { activeCurrencies, getSymbol } = useCurrencyStore()

const options = computed(() => activeCurrencies.map(currency => ({ value: currency, label: t(`currencies.${currency.toLowerCase()}_label`) + ' - ' + getSymbol(currency) })))
</script>
